
import { Component, Prop, Vue } from 'vue-property-decorator';
import { Operation, OperationCriticality } from '~/interfaces/device.interface';
import { operationsOrder } from '~/models/helpers/constants';

@Component
export default class Operations extends Vue {
    @Prop() operations!: Operation[];

    getActionCriticality(currentAction: string): OperationCriticality {
        let criticality = '';
        // find the entry [criticality, actionArray] for which the action is found in the actionArray
        const actionEntry = Object.entries(operationsOrder).find(([, actionArray]) => {
            return actionArray.find((action) => {
                return action === currentAction;
            });
        });
        // if the action was found in an entry, get the criticality (index 0 of the entry)
        if (actionEntry) {
            criticality = actionEntry[0];
        }
        return criticality as OperationCriticality;
    }

    getColor(currentAction: string): string {
        switch (this.getActionCriticality(currentAction)) {
            case 'dangerous':
                return 'error';
            case 'moderate':
                return 'primary';
            case 'harmless':
                return 'success';
        }
    }

    get sortedOperations(): Operation[] {
        return this.operations
            .sort((a, b) => {
                const criticalityOrder: OperationCriticality[] = ['harmless', 'moderate', 'dangerous'];
                const criticalityA = this.getActionCriticality(a.action);
                const criticalityB = this.getActionCriticality(b.action);
                if (criticalityA === criticalityB) {
                    const actionAIndex = operationsOrder[criticalityA].indexOf(a.action);
                    const actionBIndex = operationsOrder[criticalityA].indexOf(b.action);
                    return actionAIndex > actionBIndex ? 1 : -1;
                } else {
                    const criticalityAIndex = criticalityOrder.indexOf(criticalityA);
                    const criticalityBIndex = criticalityOrder.indexOf(criticalityB);
                    return criticalityAIndex > criticalityBIndex ? 1 : -1;
                }
            });
    }
}
